// extracted by mini-css-extract-plugin
export default {"item":"About_item__L6L-U"};